import MenuLink from "./MenuLink";

const MasteryLink = () => {
  return <MenuLink caption={"Mastery"} />;
};

export default MasteryLink;
